import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "./ui/tabs";
import { Button } from "./ui/button";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import SEOFields from "./SEOFields";

/** Per-static-page SEO override editor. Tabs across the editable static pages. */
function PageEditor({ slug, label, path }) {
  const [data, setData] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get(`/site/seo-page/${slug}`);
        setData(r.data || {});
      } catch {
        setData({});
      }
    })();
  }, [slug]);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.put(`/site/seo-page/${slug}`, data || {});
      toast.success(`SEO de « ${label} » mis à jour`);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Erreur lors de la sauvegarde");
    } finally {
      setSaving(false);
    }
  };

  if (data === null) {
    return <div className="py-8 text-center text-sm text-[#4B634B]">Chargement…</div>;
  }

  return (
    <form onSubmit={submit} className="space-y-4 max-w-2xl" data-testid={`seo-page-form-${slug}`}>
      <div className="text-xs text-[#4B634B]">Route : <code className="bg-[#F2F5F0] px-1.5 py-0.5 rounded">{path}</code></div>
      <SEOFields value={data} onChange={setData} testIdPrefix={`seo-page-${slug}`} />
      <Button type="submit" disabled={saving} className="bg-[#7AC143] hover:bg-[#67BC2A] text-white" data-testid={`seo-page-save-${slug}`}>
        {saving ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : null}
        Enregistrer
      </Button>
    </form>
  );
}

export default function SeoPagesEditor() {
  const [pages, setPages] = useState([]);

  useEffect(() => {
    api.get("/site/seo-pages").then((r) => setPages(r.data || [])).catch(() => {});
  }, []);

  if (!pages.length) return <div className="py-8 text-center text-sm text-[#4B634B]">Chargement…</div>;

  return (
    <div data-testid="seo-pages-editor">
      <Tabs defaultValue={pages[0].slug}>
        <TabsList className="flex-wrap h-auto">
          {pages.map((p) => (
            <TabsTrigger key={p.slug} value={p.slug} data-testid={`seo-page-tab-${p.slug}`}>{p.label}</TabsTrigger>
          ))}
        </TabsList>
        {pages.map((p) => (
          <TabsContent key={p.slug} value={p.slug} className="mt-6">
            <PageEditor slug={p.slug} label={p.label} path={p.path} />
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
